/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const LocationFill: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20 11.0153C20 15.866 15.1564 20.0428 13.0069 21.6576C12.3992 22.1141 11.6008 22.1141 10.9931 21.6576C8.84357 20.0428 4 15.866 4 11.0153C4 8.88948 4.84285 6.85077 6.34315 5.34762C7.84344 3.84446 9.87827 3 12 3C14.1217 3 16.1566 3.84446 17.6569 5.34762C19.1571 6.85077 20 8.88948 20 11.0153ZM12.0001 13.5001C13.3808 13.5001 14.5001 12.3808 14.5001 11.0001C14.5001 9.61935 13.3808 8.50006 12.0001 8.50006C10.6193 8.50006 9.50006 9.61935 9.50006 11.0001C9.50006 12.3808 10.6193 13.5001 12.0001 13.5001Z'
      fill='currentColor'
    />
  </React.Fragment>
)
